import React from 'react';
import { SearchInputDrawer } from '@apps/registry/common/components/Catalog/components/CatalogSearchBar/components/SearchInputDrawer';
import { Box } from '@withjoy/joykit';
import { ReactComponent as SearchSVG } from '@assets/icons/search.svg';
import { CATALOG_SEARCH_ICON_BUTTON } from '@apps/registry/common/components/Catalog/Catalog.constants';
import { useSearchBar } from '../CatalogSearchBar/hooks/useSearchBar';

export const CatalogSearchDrawerButton = () => {
  const searchBarProps = useSearchBar();

  const { handleOnOpen, handleOnClose, isSearchOpen } = searchBarProps;
  return (
    <>
      <Box
        id={CATALOG_SEARCH_ICON_BUTTON}
        _hover={{ color: 'linkHover' }}
        cursor={'pointer'}
        as="a"
        display="flex"
        justifyContent="center"
        alignItems={'center'}
        size={8}
        onClick={handleOnOpen}
      >
        <SearchSVG />
      </Box>
      <SearchInputDrawer
        {...searchBarProps}
        isOpen={isSearchOpen}
        handleOnOutsideclick={() => {
          handleOnClose('overlayClick');
        }}
        handleCancelClick={e => {
          handleOnClose('cancelButton');
        }}
      />
    </>
  );
};
